import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number): string {
  return `₪${price.toLocaleString('he-IL')}`;
}

export function formatDate(date: string): string {
  if (!date) return '';
  return new Date(date).toLocaleDateString('he-IL', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatTime(time: string): string {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  return `${hours}:${minutes}`;
}

/**
 * Validates that a URL is internal (relative or same-origin).
 * Prevents open redirect vulnerabilities by rejecting external URLs.
 */
export function isInternalUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  
  try {
    // If URL starts with / and doesn't start with // (protocol-relative), it's internal
    if (url.startsWith('/') && !url.startsWith('//')) return true;
    
    // If it's an absolute URL, check domain
    const urlObj = new URL(url, window.location.origin);
    return urlObj.origin === window.location.origin;
  } catch {
    return false;
  }
}
